module.exports = __webpack_public_path__ + "img/01.00691655.jpg";